export default {
  LOGO_DATA: 'LOGO_DATA',
  BRAND_NAME: 'BRAND_NAME',
  BRAND: 'BRAND',
  BRANDS: 'BRANDS',
}
